import React, { useState } from 'react';

import { Smartphone } from '@yandex-360/iconostasis/dist/icons/Smartphone';
import * as OrbModal from '@yandex-360/orb-components/dist/components/Modal2';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme/ScopedTheme';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { selectNewNativeAppBanner2IterationEnabled } from '../../../features/flags/selectors';
import { i18n } from '../../../helpers/i18n';
import SvgImage from '../../svg-image';
import { FooterButton, FooterButtonProps } from '../footer-button';
import footerCss from '../index.css';
import styles from './index.css';

interface Props extends Pick<FooterButtonProps, 'mode'> {
    onClick?: () => void;
}

export const InstallMobileAppButtonNew: React.FC<Props> = ({ onClick, ...props }) => {
    const [visible, setVisible] = useState(false);

    const onClose = () => setVisible(false);
    const handleButtonClick = () => {
        if (onClick) {
            onClick();
        }

        setVisible(true);
    };

    const isNewNativeAppBanner2IterationEnabled = useSelector(selectNewNativeAppBanner2IterationEnabled);

    return (
        <div>
            <FooterButton
                {...props}
                size="md"
                content={i18n(
                    'common',
                    isNewNativeAppBanner2IterationEnabled ? 'install-mobile-app-v3' : 'install-mobile-app'
                )}
                view="neutral"
                className={cn(footerCss.footerButton, footerCss.buttonInstallApp)}
                icon={<Smartphone variant="outline" size="md" />}
                onClick={handleButtonClick}
            />
            <ScopedTheme theme="light">
                <OrbModal.Modal visible={visible} onClose={onClose}>
                    <OrbModal.NavigationBar closable />
                    <OrbModal.Slot className={styles.content}>
                        <SvgImage className={styles.qr} imageName="nativeAppBannerModal" />
                        <div className={styles.titleAndDescription}>
                            <Text typography="heading-lg">{i18n('native-app-banner', 'title-v2')}</Text>
                            <Text typography="body-lg-regular">{i18n('native-app-banner', 'description-v2')}</Text>
                        </div>
                    </OrbModal.Slot>
                </OrbModal.Modal>
            </ScopedTheme>
        </div>
    );
};
